import columns from '../../../react-table/helpers/columns';
import TableDefinitions from '../../../../common/TableDefinitions';

export function getCopyEdiRfidRequest(rowInfo) {
  return rowInfo && rowInfo.row ? {
    path: '/edi-rfid-audit/create',
    tableId: TableDefinitions.EDI_RFID_AUDIT_REQUESTS_LIST_PAGE.id,
    text: 'Copy',
  } : {};
}

export default (data) => {
  const {
    DateColumn,
    NumberColumn,
    TextColumn,
    TextCommaColumn,
    NavigationColumn,
    EditButtonColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Audit File Name', 'auditFilename'),
        new TextCommaColumn('Outbound Operator', 'outboundOperators'),
        new TextCommaColumn('Outbound IMPC', 'outboundImpcs'),
        new TextCommaColumn('Inbound Operator', 'inboundOperators'),
        new TextCommaColumn('Inbound IMPC', 'inboundImpcs'),
        new TextColumn('Type', 'type'),
        new NumberColumn('Execution Moment', 'executionMoment'),
        new DateColumn('Start Date', 'startDate'),
        new DateColumn('End Date', 'stopDate'),
        new NavigationColumn(new EditButtonColumn('Copy', 'auditFilename'), getCopyEdiRfidRequest),
      ],
    },
  ];
};
